




















































import {
  defineComponent,
  computed
} from '@vue/composition-api'

import AnslDatePicker from '@/components/common/DatePicker.vue'
import DeliverySelector from './DeliverySelector.vue'
import DeliveryText from '@/components/common/DeliveryText.vue'

import {
  getSelectedAlternativeDelivery,
  getSelectedOperatorChangeDate,
  setSelectedAlternativeDelivery,
  setSelectedOperatorChangeDate
} from '@/store/modules/order-flow.store'

import { isAreaTypeChangeOperator } from '@/utils/area.utils'
import {
  formatDateIso,
  operatorChangeDateOptions
} from '@/utils/date.utils'

export default defineComponent({
  components: {
    AnslDatePicker,
    DeliverySelector,
    DeliveryText
  },
  props: {
    areaTypeName: {
      type: String,
      required: true
    },
    useDeliveryOptions: {
      type: Boolean,
      required: true
    },
    campaignDeliveryDateStart: {
      type: String,
      default: ''
    },
    campaignDeliveryDateEnd: {
      type: String,
      default: ''
    },
    campaignContractLastDate: {
      type: String,
      default: ''
    }
  },
  setup (props, context) {
    const store = context.root.$store

    const deliveryStartDate = computed(() => formatDateIso(props.campaignDeliveryDateStart))
    const deliveryEndDate = computed(() => formatDateIso(props.campaignDeliveryDateEnd))
    const orderDeadline = computed(() => formatDateIso(props.campaignContractLastDate))

    const operatorChangeDate = computed({
      get: () => getSelectedOperatorChangeDate(store),
      set: (input: string | null) => setSelectedOperatorChangeDate(store, input)
    })

    const alternativeDelivery = computed({
      get: () => getSelectedAlternativeDelivery(store),
      set: (input: boolean | null) => setSelectedAlternativeDelivery(store, !!input)
    })

    return {
      alternativeDelivery,
      isAreaTypeChangeOperator,
      operatorChangeDateOptions,
      operatorChangeDate,
      deliveryStartDate,
      deliveryEndDate,
      orderDeadline
    }
  }
})
